import { Nullable } from '@enmon/commons';
import { RECORD_TYPE_TO_FALSE_IMPORT_FIELDS_MAP } from '@enmon/commons/lib/enmon';
import { Commodity } from '@enmon/commons/lib/shared';

/**
 * Checks if a given field key is considered a false import field for a specific commodity.
 *
 * @param commodity - The meter commodity to check against
 * @param key - The field key to validate
 * @returns `true` if the field is a false import field for the given commodity, `false` otherwise
 */
export function isFalseImportField(commodity: Nullable<Commodity>, key: string): boolean {
  if (!commodity) return false;
  const fields = RECORD_TYPE_TO_FALSE_IMPORT_FIELDS_MAP[commodity];
  return !!fields && fields.includes(key);
}
